



































































































































































































































import { Component, Vue } from "vue-property-decorator";
import "@/styles/Profile.scss";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { GeneralService } from "../services/general-service";
import config from "../services/api-config";
import router from "../router";
import VueApexCharts from "vue-apexcharts";
import AuthService from "../services/auth-service";
import Answer from "@/components/Answer.vue";
import store from "../store";

declare var require: any;

Vue.use(VueApexCharts);

@Component({
  components: {
    swiper,
    swiperSlide,
    apexchart: VueApexCharts,
    answer: Answer,
  },
})
export default class Profile extends Vue {
  private service = new GeneralService();
  private entities: GActivity[] = [];
  private answers: ProvidedAnswers[] = [];
  private level_id;
  private auth = new AuthService();
  private videoTopics: nextToWatch[] = [];
  private statistics: Statistics[] = [];
  private isQuestion = false;
  private subjects: QuestionS[] = [];
  private isAttempt = false;
  private series: any = [0, 0, 0];
  private labels: any = [];
  private isFB = false;
  private showAll = true;
  private selectedPart = 0;
  private hasMultiple = false;
  private studentInfo: any = [];

  private chartOptions = {
    plotOptions: {
      radialBar: {
        dataLabels: {
          name: {
            fontSize: "22px",
            color: "white",
          },
          value: {
            fontSize: "16px",
            color: "white",
          },
          total: {
            show: true,
            label: "Overall",
            color: "white",
            formatter: function (w) {
              return (
                Math.round(
                  w.globals.seriesTotals.reduce((a, b) => {
                    return a + b;
                  }, 0) / w.globals.series.length
                ) + "%"
              );
            },
          },
        },
      },
    },
    labels: this.labels,
  };

  swiperOption = {
    slidesPerView: 1,
    allowTouchMove: false,
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
  };

  async findNotWatched(id) {
    let topicId;
    await this.service.chapters(id).then((result) => {
      if (result.findIndex((e) => e.fullName == "Promo") > -1) {
        result.splice(
          result.findIndex((e) => e.fullName == "Promo"),
          1
        );
      }
      for (let entity of result) {
        topicId = this.poolChapter(entity.id);
        if (topicId !== null) {
          break;
        }
      }
    });
    return topicId;
  }

  async poolChapter(id) {
    let topicId;
    await this.service.topics(id).then((result) => {
      for (let entity of result) {
        if (entity.maxWatched == 0 && entity.id !== null) {
          topicId = entity;
          break;
        }
      }
    });

    return topicId;
  }

  videoSelected(id) {
    this.$store.state.topicSelectId = id;
    this.$store.state.selectSubject = id;
    this.$store.state.selectSubjectName = undefined;
    this.$store.state.chapterSelectName = undefined;
    router.push({ name: "videotopic", params: { videoSelected: "true" } });
  }

  getImgUrl(pet) {
    const images = require.context("@/assets/images/icons/", false, /\.svg$/);
    try {
      return images("./" + pet + ".svg");
    } catch {
      // return images('./error.png')
    }
  }

  setQuestion(subjId: string) {
    this.service.setDailyQuestion(subjId + ":" + this.auth.session.userId);
  }

  getQuestions(subjId: string, subjname: string) {
    const t = this;
    this.service
      .getDailyQuestion(subjId + ":" + this.auth.session.userId)
      .then(function (result) {
        t.subjects.push({
          subjectid: subjId,
          subjectname: subjname,
          question: result[0],
        });
        t.isQuestion = true;
      });
  }

  async switchSlide(response, subjid) {
    if (this.answers !== undefined && response !== undefined) {
      const uuid = response.questionId + ":" + subjid;
      const date = new Date();
      this.service.saveDailyQuestion(
        uuid,
        date,
        response.styles == "green" ? true : false
      );
    }

    setTimeout(() => {
      (this.$refs.mySwiper as any).swiper.slideNext(1000, false);
      if ((this.$refs.mySwiper as any).swiper.isEnd) {
        this.series = [];
        this.labels = [];
        for (let subject of this.subjects) {
          this.chartOptions.labels.push(subject.subjectname);
          this.service.getGlobalStatistics(subject.subjectid).then((result) => {
            this.statistics.push({
              subjectname: subject.subjectname,
              stat: result[0].statistics,
            });
            this.series.push(result[0].statistics);
          });
        }

        localStorage[config.dailyQuestion] = JSON.stringify({
          val: true,
          user: this.auth.session.userId,
          timestamp: new Date().getUTCDate(),
        });
      }
    }, 1500);
  }

  compareTime(date1, date2) {
    return date1 == date2;
  }

    private switchPart(){
        if (this.selectedPart == 0)
            this.selectedPart = 1;
        else 
            this.selectedPart = 0;

        localStorage[config.userInfoEMS]  = this.studentInfo[this.selectedPart].Class_Level_ID;
    }

  mounted() {
    this.level_id = JSON.parse(localStorage[config.programSelect] || null);
    const attempt = JSON.parse(localStorage[config.dailyQuestion] || null);
    const today = new Date().getUTCDate();

    if (
      this.level_id == "" ||
      this.level_id == undefined ||
      this.level_id == "null" ||
      this.level_id.user !== this.auth.session.userId
    ) {
      router.push("select");
    }

    // if (attempt && attempt.val && attempt.timestamp && attempt.user == this.auth.session.userId && this.compareTime(today, attempt.timestamp)){
    //   this.isAttempt = true;
    // }

    let username = this.auth.session.userName.split("@")[0];
    this.service.getInfoEMS(username).then((result) => {
      this.studentInfo = result.data;
      this.selectedPart = result.data.length - 1;
      this.hasMultiple = result.data.length > 1 ? true : false;
      localStorage[config.userInfoEMS] = this.studentInfo[
        this.selectedPart
      ].Class_Level_ID;
    });

    this.service
      .subjects(this.level_id.val)
      .then((result) => {
        this.entities = result;
        let arr: nextToWatch[] = [];
        for (let entity of result) {
          this.findNotWatched(entity.id).then(function (result) {
            if (result !== null) {
              arr.push({ subject: entity.fullName, data: result });
            }
          });

          // this.getQuestions(entity.id, entity.fullName);
        }

        this.videoTopics = arr;
      })
      .catch((err) => {
        console.error(`Error: ${err.message}`);
      });
  }
}

interface nextToWatch {
  subject: string;
  data: GActivity;
}

interface ProvidedAnswers {
  questionId: string;
  answer: boolean;
}

interface QuestionS {
  subjectid: string;
  subjectname: string;
  question: QuestionE;
}

interface Statistics {
  subjectname: string;
  stat: number;
}
